import { useState, useEffect } from "react";
import { Form, Drawer, Button, Modal } from "antd";
import { gql, useMutation, useLazyQuery } from "@apollo/client";
import MeetingRoomInputs from "../inputs/meetingRoom";
import ContractTemplateEditor from "@general/contractTemplateEditor";

const CRERATEPRODUCT = gql`
  mutation createMeetingRoom($createMeetingRoomInput: CreateMeetingRoomInput!) {
    createMeetingRoom(createMeetingRoomInput: $createMeetingRoomInput) {
      id
      name
    }
  }
`;
const GETWPCONTRACTVARIABLES = gql`
  query {
    getProductContractVariable {
      name
      title
    }
  }
`;
function AddMeetingRoom() {
  const [error, setError] = useState(null);
  const [meetingRoomContractDrawer, setMeetingRoomDrawer] = useState(false);
  const [meetingRoomContract, setMeetingRoomContract] =
    useState("<html></html>");
  const [wpContractVariables, setWpContractVariable] = useState();

  const [form] = Form.useForm();
  const [getContractVariables, contrcatVariables] = useLazyQuery(
    GETWPCONTRACTVARIABLES,
    {
      onCompleted({ getProductContractVariable }) {
        setWpContractVariable(getProductContractVariable);
      },
      onError(e) {
        console.log("error: " + e.message);
      },
    }
  );
  const [runCreateProduct, createProduct] = useMutation(CRERATEPRODUCT, {
    onCompleted({ createMeetingRoom }) {
      Modal.success({
        content: `${createMeetingRoom?.name} به خدمات صفاتک اضافه شد.`,
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
        onOk: () => form.resetFields(),
      });
    },
    onError(err) {
      console.log("خطا: " + err.message);
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: "لطفا دوباره تلاش کنید!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
  });

  useEffect(() => {
    getContractVariables();
  }, []);
  const doCreateProduct = (createMeetingRoomInput) => {
    runCreateProduct({
      variables: {
        createMeetingRoomInput: {
          ...createMeetingRoomInput,
          contract: meetingRoomContract,
        },
      },
    });
  };


  return (
    <>
      <Drawer
        title={"تعهدنامه استفاده از فضای کار"}
        placement="top"
        open={meetingRoomContractDrawer}
        onClose={() => setMeetingRoomDrawer(false)}
        height={550}
      >
        <ContractTemplateEditor
          contract={meetingRoomContract}
          onCloseDrawer={() => setMeetingRoomDrawer(false)}
          onEditContract={(newContract) => setMeetingRoomContract(newContract)}
          helpVars={wpContractVariables?.filter(v=> v.name != "START_DATE" && v.name != "END_DATE")}
        />
      </Drawer>
      <Form layout="vertical" onFinish={doCreateProduct} form={form}>
        <MeetingRoomInputs
          error={error}
          onSetMeetingRoomDrawer={setMeetingRoomDrawer}
        />
        <Button
          type="primary"
          htmlType="submit"
          loading={createProduct.loading && true}
        >
          ثبت خدمت
        </Button>
      </Form>
    </>
  );
}

export default AddMeetingRoom;
